import styled from '@emotion/styled'
import { useTranslation } from 'next-i18next'
import { UiIcon } from 'modules/ui/atoms/Icon'
import { CLASSY_DESIGN_TOKENS } from '../../../../../tokens'
import { DEFAULT_FONT_STYLES } from 'css/theme'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${CLASSY_DESIGN_TOKENS['--classy-color__neutral--30']};
  font-size: ${DEFAULT_FONT_STYLES['--theme-font--caption__font-size']};
  gap: 4px;
  line-height: 16px;
`

export const PaymentMethodSecureNotice = () => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <UiIcon w={24} h={24} name="shield" />
      {t('PaymentMethodsStep.sslInfo.encryptedMessage', 'Secure and encrypted')}
    </Wrapper>
  )
}
